var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FBE2E2;}\r\n\t.st1{fill:none;stroke:#DA0B0B;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,0L12,0c6.6,0,12,5.4,12,12l0,0c0,6.6-5.4,12-12,12l0,0C5.4,24,0,18.6,0,12l0,0C0,5.4,5.4,0,12,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.7,7.8l-8.9,8.9 M18.9,12c0,3.8-3.1,6.9-6.9,6.9S5.1,15.8,5.1,12S8.2,5.1,12,5.1S18.9,8.2,18.9,12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.c3e6cc10fff739f17c136939f23f5465.svg";
export { ForwardRef as ReactComponent };